const InteractionEventName = {};
export default InteractionEventName;

InteractionEventName.MOVE = "move";
InteractionEventName.START_PUZZLE = "start_puzzle";
InteractionEventName.SOLVE_PUZZLE = "puzzle_solved";
InteractionEventName.FAIL_PUZZLE = "puzzle_failed";
InteractionEventName.SKIP_PUZZLE = "puzzle_skipped";